module.exports = __webpack_public_path__ + "img/Kingos-salmebok_Bilde-til-den-gyldne-sol-frembryder.885770e6.jpg";